import { Post } from "../../helpers/apicalls/apicalls";
import * as actionTypes from "./WidgetTypes.js";

export const addWidget = (data, token, message) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.WIDGET_IS_LOADING
    });
    Post("/agents/user/widget", data, token)
      .then((res) => {
        if (res.status) {
          dispatch({
            type: actionTypes.WIDGET_ADDED_SUCCESS,
            payload: res.data
          });
          message.success("Changes added successfully");
        }
        else {
          dispatch({
            type: actionTypes.WIDGET_ADDED_FAILED,
          });
          message.error("unsuccessful");
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.WIDGET_ADDED_FAILED,
        });
      });
  };
};

export const getWidgetdata = (data) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.IS_LOADING_GET
    });
    Post("/agents/user/get-widget", data)
      .then((res) => {

        if (res.status) {
          dispatch({
            type: actionTypes.WIDGET_GET_SUCCESS,
            payload: res.data
          });
        }
        else {
          dispatch({
            type: actionTypes.WIDGET_GET_FAILED,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.WIDGET_GET_FAILED,
        });
      });
  };
};


export const getGreetingData = (data, token) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.IS_LOADING_GREETING
    });
    Post("/agents/user/get-greetings", data, token)
      .then((res) => {
        if (res.status) {
          dispatch({
            type: actionTypes.GREETING_SUCCESS,
            payload: res.data
          });
        }
        else {
          dispatch({
            type: actionTypes.GREETING_FAILED,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.GREETING_FAILED,
        });
      });
  };
};


export const addGreetings = (data, token, onSuccess) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.IS_LOADING_ADD_GREETING
    });
    Post("/agents/user/add-greetings", data, token)
      .then((res) => {
        if (res.status) {
          onSuccess(res?.message);
          dispatch({
            type: actionTypes.ADD_GREETING_SUCCESS,
            payload: res.data
          });

        }
        else {
          dispatch({
            type: actionTypes.ADD_GREETING_FAILED,
          });
        }
      })
      .catch((err) => {
        dispatch({
          type: actionTypes.ADD_GREETING_FAILED,
        });
      });
  };
};



